import { memo } from 'react';
import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';

import { getBooleanLabel } from '@gef-ui/localization/messages';
import { joinString } from '@gef-ui/utils';

import { PKUrl } from 'components';
import { equalOrThreeDashes, fromIsoDate } from 'utils';

export const CommunicationOverviewTableRow = ({ communicationGroup = {} }) => {
	const {
		representativeSurname,
		representativeFirstname,
		partnerId,
		createdDate,
		partnerName,
		channelText,
		distributionChannelText,
		subActivitiesBCT,
		requestForCancellation,
		subActivitiesSale,
	} = communicationGroup;

	const representativeName = joinString(' ', [representativeSurname, representativeFirstname]);

	return (
		<>
			<TableCell>{equalOrThreeDashes(fromIsoDate(createdDate))}</TableCell>
			<TableCell>
				<PKUrl.PKPartner partnerId={partnerId} muiLink>
					{equalOrThreeDashes(partnerName)}
				</PKUrl.PKPartner>
			</TableCell>
			<TableCell>{equalOrThreeDashes(channelText)}</TableCell>
			<TableCell>
				<div>{equalOrThreeDashes(representativeName)}</div>
				<div>{equalOrThreeDashes(distributionChannelText)}</div>
			</TableCell>
			<TableCell>{equalOrThreeDashes(subActivitiesBCT)}</TableCell>
			<TableCell>
				<div>{equalOrThreeDashes(getBooleanLabel(requestForCancellation))}</div>
				<div>{equalOrThreeDashes(subActivitiesSale)}</div>
			</TableCell>
		</>
	);
};

CommunicationOverviewTableRow.propTypes = {
	communicationGroup: PropTypes.object,
};

export default memo(CommunicationOverviewTableRow);
